<template>
    <div>
        <div class="form-group">
            <label>Target Url</label>
            <input type="text" class="form-control" v-model="data.targetUrl">
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data'
    ],
    data() {
        return {
        };
    }
}
</script>
